import { create } from '@bufbuild/protobuf'
import { type ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { getDemandSuppressionMaster } from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'
import {
  GetDemandSuppressionMasterRequestSchema,
  type GetDemandSuppressionMasterResponse,
} from '@ebalance/proto/bffuser/v1/occto_master_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 需要抑制計画マスタ full entity 取得 hook。
 * contracts / partnerBgs を含む全フィールドを返す。Edit modal の form 初期値に使用する。
 * id が undefined または空文字の場合は query を無効化する。
 */
export function useGetDemandSuppressionMaster(
  id: string | undefined,
): UseQueryResult<GetDemandSuppressionMasterResponse, ConnectError> {
  return useQuery(
    getDemandSuppressionMaster,
    create(GetDemandSuppressionMasterRequestSchema, { id: id ?? '' }),
    { enabled: id !== undefined && id !== '' },
  )
}
